// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AssetRenderer-module__container {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    padding: 20px;
    gap: 20px;
    flex: 2;
    height: auto;
    background-color: #4E4B66;
    border: 1px solid #E6E8F0;
    border-radius: 10px;
}

.AssetRenderer-module__heading {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 45px;
    background-color: #6E7191;
    color: white;
    font-family: Montserrat;
    font-weight: 600;
    font-size: 14px;
    line-height: 100%;
    letter-spacing: 8%;
    text-align: center;
    text-transform: uppercase;
    border-radius: 12px;
}

.AssetRenderer-module__errorMessage {
    color: red;
    font-family: Montserrat;
    font-size: 16px;
    text-align: center;
    margin-top: 20px;
}

.AssetRenderer-module__assetContainer{
    background: white;
    overflow-y: auto;
    width: 100%;
    max-height: 400px;
}

`, "",{"version":3,"sources":["webpack://./src/components/assetrenderer/AssetRenderer.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,oBAAoB;IACpB,aAAa;IACb,SAAS;IACT,OAAO;IACP,YAAY;IACZ,yBAAyB;IACzB,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,yBAAyB;IACzB,YAAY;IACZ,uBAAuB;IACvB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,uBAAuB;IACvB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,WAAW;IACX,iBAAiB;AACrB","sourcesContent":[".container {\n    display: flex;\n    flex-direction: column;\n    align-items: stretch;\n    padding: 20px;\n    gap: 20px;\n    flex: 2;\n    height: auto;\n    background-color: #4E4B66;\n    border: 1px solid #E6E8F0;\n    border-radius: 10px;\n}\n\n.heading {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 45px;\n    background-color: #6E7191;\n    color: white;\n    font-family: Montserrat;\n    font-weight: 600;\n    font-size: 14px;\n    line-height: 100%;\n    letter-spacing: 8%;\n    text-align: center;\n    text-transform: uppercase;\n    border-radius: 12px;\n}\n\n.errorMessage {\n    color: red;\n    font-family: Montserrat;\n    font-size: 16px;\n    text-align: center;\n    margin-top: 20px;\n}\n\n.assetContainer{\n    background: white;\n    overflow-y: auto;\n    width: 100%;\n    max-height: 400px;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `AssetRenderer-module__container`,
	"heading": `AssetRenderer-module__heading`,
	"errorMessage": `AssetRenderer-module__errorMessage`,
	"assetContainer": `AssetRenderer-module__assetContainer`
};
export default ___CSS_LOADER_EXPORT___;
